<template>
    <div class="new-info-list-wrap">
      <!-- 业签 -->
      <div :class="{fixTop:fixTop}" :style="{ top: posObj && `${posObj.headerHeight || 0}px` || 0 }">
        <van-tabs  v-model="active" @click="listSelect">
          <van-tab  v-for="tag in tagList" :title="tag.name" :key="tag.id"></van-tab>
        </van-tabs>
      </div>
      <div v-if="fixTop" :style="{ height: posObj && `${posObj.headerHeight || 0}px` || 0 }"></div>
      <!-- 列表 -->
      <van-list :immediate-check=false v-model="loading" loading-text="加载中" :finished="finished" @load="getDataList" v-if="params.total>0" v-cloak>
          <list :params="params"></list>
      </van-list>
      <div class="no-data" v-else>
        <img src="https://project-homedo.oss-cn-shanghai.aliyuncs.com/bd9f18a8-2069-4276-b6f2-9fe35dfba78e_nn-d.png" alt="">
        <div>暂无内容</div>
      </div>
      <div v-if="isShowZ" class="show-z"></div>
    </div>
</template>

<script>
import headers from '@/components/headers'
import search from '@/components/search'
import list from '@/components/newList'
import noResult from '@/components/noResult'
import { getColumnList, getColumnLabel } from '@/api/news/news'
import wxAuth from '@/components/wxAuth'
export default {
  name: 'news-list',
  props: ['posObj'],
  components: { search, list, noResult, wxAuth, headers },
  data () {
    return {
      fixTop: false,
      isShowZ: false,
      share: {
        title: '解决方案馆',
        desc: '智能化产品方案,产品方案,系统方案,弱电设备方案,厂商方案,产品供应商设计方案,弱电设计方案,热门方案,规划设计方案,顶层设计方案,系统解决方案,集成商方案,招标方案,投标方案,深化设计方案,施工方案',
        imgUrl: 'https://image01.homedo.com/Files/Images/cms/www/20171225/4970465306687879653_pic1.jpg',
        url: window.location.href.split('#')[0]
      },
      hraderP: {
        title: '河姆渡方案馆',
        lefticon: true
      },
      searchParam: {
        type: 'search03',
        placeholder: '',
        callback: 'callback',
        filterType: 'news',
        url: '/hadoop/list.html'
      },
      params: {
        list: [],
        type: 'info',
        label: 'true',
        total: 1
      },
      listQuery: {
        pageNum: 1,
        pageSize: 15
      },
      noResultData: {
        type: 2,
        typeName: '资讯'
      },
      active: 0,
      loading: false,
      finished: false,
      tagList: [],
      currIndex: 0
    }
  },
  mounted () {
    this.getColumnTag()
    this.getListBefore()
    window.onscroll = () => {
      let scroolT = document.documentElement.scrollTop || document.body.scrollTop
      this.fixTop = scroolT > (this.posObj && this.posObj.scrollHeight)
    }
  },
  methods: {
    getColumnTag () {
      getColumnLabel().then(res => {
        if (res.data && res.data.code === 200) {
          this.tagList = res.data.data.list.filter(v => {
            return v.name !== '每日三分钟'
          })
          const obj = {
            id: 0,
            name: '全部资讯'
          }
          this.tagList.unshift(obj)
          // for (var i = 0; i < this.tagList.length; i++) {
          //   if (this.tagList[i].name === this.$route.query.tagName) {
          //     this.active = i
          //   }
          // }
          // this.$nextTick(() => {
          //   if (this.active > 2) {
          //     document.querySelectorAll('.van-tabs__wrap--scrollable')[0].children[0].scrollLeft = 50 * this.active
          //   }
          // })
        }
      })
    },
    listSelect (index, title) {
      console.log(this.tagList)
      this.active = index
      this.params.list = []
      this.params.total = 1
      this.listQuery = Object.assign({}, this.listQuery, {
        pageNum: 1,
        pageSize: 15,
        tagName: title !== '全部资讯' ? title : ''
      })
      this.getList('scroll')
      this.isShowZ = true
    },
    // 在获取列表数据之前做的判断,isNoResult 用处是  点击随便看看，应该把筛选的条件删除
    getListBefore () {
      this.params.list = []
      this.params.total = 1
      this.listQuery = Object.assign({}, this.listQuery, {
        pageNum: 1,
        pageSize: 15
      })
      if (!this.$route.query.tagName) {
        delete this.listQuery.tagName
        this.active = 0
      } else {
        this.listQuery.tagName = this.$route.query.tagName
      }
      this.getList()
    },
    // list组件需要的方法
    getDataList () {
      if ((this.params.list.length >= this.params.total) && this.params.total !== 0) {
        this.finished = true
      } else {
        this.listQuery.pageNum++
      }
      this.getList()
    },
    // 只是获取数据
    getList (type) {
      getColumnList(this.listQuery).then(res => {
        this.loading = false
        this.isShowZ = false
        if (res.data.code === 200) {
          this.params.total = res.data.data.total
          res.data.data.list.forEach(item => {
            this.params.list.push(item)
          })
          if (this.params.list.length >= this.params.total) {
            this.finished = true
          } else {
            this.finished = false
          }
          if (type === 'scroll') {
            this.$nextTick(() => {
              window.scrollTo(0, this.posObj.scrollHeight)
            })
          }
        }
      }).catch(() => {
        this.loading = false
        this.params.total = 0
        this.isShowZ = false
      })
    }
  }
}
</script>

<style lang="scss">
  .new-info-list-wrap {
    .van-tab {
      font-size: 16px;
      color: rgba(0,0,0,0.45);
    }
    .van-tab--active {
      color: #2F7BFF;
      font-weight: bold;
    }
    .van-tabs__line {
      height: 2px;
      background-color: #2F7BFF!important;
    }
    .fixTop {
      position: fixed;
      left: 0;
      right: 0;
    }
    .show-z {
      height: calc(100vh - 90px);
    }
    .no-data {
      height: calc(100vh - 90px);
      img {
        width: 160px;
        height: auto;
        margin: 24px auto 0;
        display: block;
      }
      div {
        margin-top: 15px;
        font-size: 14px;
        font-family: PingFangSC, PingFangSC-Regular;
        font-weight: 400;
        text-align: center;
        color: rgba(0,0,0,0.65);
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/view/indexTemplate/news.vue